"use strict";

exports.__esModule = true;
exports.BY_DEVICE_COLUMN = void 0;
exports.normalizeAiDocument = normalizeAiDocument;
exports.normalizeAiElement = normalizeAiElement;
// svc-ai returns a document that is valid against the widget manifest but not
// always complete for the screen. A Metric Table draws its rows from a
// "group by" column (section "aggregates") that the report editor adds with
// the metric columns; svc-ai sends the metric columns alone, so the query
// goes out with no bins and the table has nothing to show. Until the service
// adds the column itself, give such a table the editor's "by device" column.

// The column the editor makes for "Group by: Device":
// createTableColumns(flattenAggregates([byDevice]))[0], written out so the
// draft store (a leaf module) does not pull the widget tree in.
var BY_DEVICE_COLUMN = exports.BY_DEVICE_COLUMN = {
  type: "AdvancedDataTableColumn",
  props: {
    hideTypeSelector: true,
    canFilter: false,
    section: "aggregates",
    id: "device",
    groupId: "device",
    groupLabel: "Device",
    sanitizedFieldName: "Device",
    name: "device",
    label: "Device",
    type: "deviceName",
    sortIndex: "device"
  },
  children: []
};
var sectionOf = function sectionOf(child) {
  return child && child.props && child.props.section;
};
function needsGroupBy(element) {
  if (element.type !== "MetricTable" || !Array.isArray(element.children)) {
    return false;
  }
  var columns = element.children;
  return columns.some(function (child) {
    return sectionOf(child) === "metrics";
  }) && !columns.some(function (child) {
    return sectionOf(child) === "aggregates";
  });
}

/**
 * The element tree with every grouping-less Metric Table given a "by device"
 * column. Returns the same object when nothing needed changing.
 */
function normalizeAiElement(element) {
  if (!element || typeof element !== "object") {
    return element;
  }
  var changed = false;
  var children = element.children;
  if (Array.isArray(children)) {
    var next = children.map(normalizeAiElement);
    if (next.some(function (child, index) {
      return child !== children[index];
    })) {
      children = next;
      changed = true;
    }
  }
  if (needsGroupBy(element)) {
    children = [BY_DEVICE_COLUMN].concat(children);
    changed = true;
  }
  return changed ? Object.assign({}, element, {
    children: children
  }) : element;
}

/**
 * A dashboard or report document from svc-ai, made complete for the screen.
 */
function normalizeAiDocument(document) {
  if (!document || typeof document !== "object") {
    return document;
  }
  var element = normalizeAiElement(document.element);
  return element === document.element ? document : Object.assign({}, document, {
    element: element
  });
}